import { useFormik } from "formik";
import { Flex, FormControl, FormLabel, Select as ChakraSelect, Input as ChakraInput, Button } from "@chakra-ui/react";
import { CustomersFilter } from "../_helpers";
import { Recruiter } from "@/model/recruiters";

export interface CustomersPopupFilterProps {
  readonly values: CustomersFilter;
  readonly onApply: (values: CustomersFilter) => void;
  readonly onReset: () => void;
  readonly businessAreaOptions: readonly { value: string; label: string }[];
  readonly recruiters: readonly Recruiter[];
}

export const CustomersPopupFilter = ({ values, onApply, onReset, businessAreaOptions, recruiters }: CustomersPopupFilterProps) => {
  const formik = useFormik<CustomersFilter>({
    initialValues: values,
    enableReinitialize: true,
    onSubmit: (v) => onApply(v),
  });

  return (
    <>
      <FormControl>
        <FormLabel>Сфера деятельности</FormLabel>
        <ChakraSelect
          placeholder="Выберите сферу"
          value={formik.values.business_area || ""}
          onChange={(e) => formik.setFieldValue("business_area", e.target.value || "")}
        >
          {businessAreaOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </ChakraSelect>
      </FormControl>

      <FormControl>
        <FormLabel>Аккаунт-менеджер</FormLabel>
        <ChakraSelect
          placeholder="Выберите менеджера"
          value={formik.values.responsible_id ?? ""}
          onChange={(e) => formik.setFieldValue("responsible_id", e.target.value || undefined)}
        >
          {recruiters.map((r) => (
            <option key={r.id} value={r.id}>
              {r.username}
            </option>
          ))}
        </ChakraSelect>
      </FormControl>

      <FormControl>
        <FormLabel>Дата</FormLabel>
        <Flex gap="12px">
          <ChakraInput
            type="date"
            value={formik.values.created_at_from || ""}
            onChange={(e) => formik.setFieldValue("created_at_from", e.target.value || "")}
          />
          <ChakraInput
            type="date"
            value={formik.values.created_at_to || ""}
            onChange={(e) => formik.setFieldValue("created_at_to", e.target.value || "")}
          />
        </Flex>
      </FormControl>
      <Flex justifyContent="flex-end" gap="8px">
        <Button variant="ghost" onClick={onReset}>
          Сбросить
        </Button>
        <Button onClick={() => void formik.submitForm()} bg="#2563eb" color="white" _hover={{ bg: "#2563eb" }} _active={{ bg: "#2563eb" }}>
          Применить
        </Button>
      </Flex>
    </>
  );
};
